import React from 'react'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import PropTypes from 'prop-types'

const TreatmentSubmitModule = ({ moduleName, moduleValues, submitModule }) => (
  <Grid item xs={12}>
    <Button
      onClick={() => submitModule(moduleName, moduleValues)}
      variant="contained"
      color="success"
      fullWidth
    >
      Submit
    </Button>
  </Grid>
)

TreatmentSubmitModule.propTypes = {
    moduleName: PropTypes.string.isRequired,
    moduleValues: PropTypes.object.isRequired,
    submitModule: PropTypes.func.isRequired
}

export default TreatmentSubmitModule